import Enum from "../../../../../../enums/Enum";

const MyotomesSacralEnum = new Enum({
    M_S1: {value: "S1 - Ankle Planta flexion and eversion, hip Extension, Knee Flexion"},
    M_S2: {value: "S2 - Knee Flexion"},
    M_S3: {value: "S3 - Rectal Sphincter Tone"},
});

export default MyotomesSacralEnum;